import React, { useState, useMemo, useRef, memo } from 'react';
import { GetAllUsers, DeleteUser } from "../../../api/endpoints";
import AddEditUser from './CUUser';
import ReportContent from '../../../components/tableDrawer/reportContent';
import ReportHeader from '../../../components/tableDrawer/reportHeader';
import ReportSearch from '../../../components/tableDrawer/reportSearch';
import DeleteBtn from '../../../components/tableDrawer/TableItems/components/tableActions/DeleteBtn';
import EditBtn from '../../../components/tableDrawer/TableItems/components/tableActions/EditBtn';
import ScreenHeader from '@/components/ScreenHeader';
import ActionBtn from '@/components/ActionBtn';


const UsersC = () => {
    const [UserID, setUserID] = useState(null);

    const insertModal = useRef("insertUserModal")
    const updateModal = useRef("UpdateUserModal")

    const columns = useMemo(
        () => [

            {
                Header: 'Name',
                accessor: 'name',
                canSearch: true

            },
            {
                Header: 'Email',
                accessor: 'email',
                canSearch: true
            },
            {
                Header: 'Role',
                accessor: 'roleName'
            },
            {
                id: 'action',
                Cell: ({ row: { original } }) => {
                    return (
                        <>
                            <EditBtn onApply={updateUser} id={original?.id} />
                            <DeleteBtn api={DeleteUser} id={original.id} />
                        </>
                    )
                }
            }
        ], []
    )

    const updateUser = (userID) => {
        setUserID(userID);
        updateModal.current.click()
    }

    const openInsertModal = () => {
        insertModal.current.click()
    }

    return (
        <>
            <AddEditUser modalID={insertModal} />
            <AddEditUser rowId={UserID} modalID={updateModal} />

            <ScreenHeader title="users-report">
                <ActionBtn onApply={() => insertModal.current.click()} title="add-user" className="accept-btn" icon={"mdi:plus"} />
            </ScreenHeader>
            <ReportContent tableAPI={GetAllUsers} columns={columns}>
                <ReportHeader ApplyAction={openInsertModal} ActionName={"adit-user"}>
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>

        </>
    );
}

export default memo(UsersC);